import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "highlights-content"
}
const _hoisted_2 = {
  key: 1,
  class: "highlights__empty-container"
}

import { computed } from 'vue'

import Highlight from '@/app/components/doc/highlights/Highlight.vue'
import AppButton from '@/app/components/button/AppButton.vue'

import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightsList',
  props: {
    doc: {},
    limit: { default: 0 },
    hideButtonOnMobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const highlightsQty = computed(() => {
  if (props.limit === 0) {
    return props.doc.highlights.length
  }
  return props.limit
})

const readingButton = computed(() => {
  return props.doc.startReadingButton()
})

const hideButtonClass = computed(() => {
  return props.hideButtonOnMobile
    ? 'highlights__read-button--hide-on-mobile'
    : ''
})

return (_ctx: any,_cache: any) => {
  return (__props.doc.hasHighlights)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.highlights.slice(0, highlightsQty.value), (highlight) => {
          return (_openBlock(), _createBlock(Highlight, {
            key: highlight.id,
            highlight: highlight,
            doc: __props.doc,
            content: __props.doc.currentPage
          }, null, 8, ["highlight", "doc", "content"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"highlights__image-wrapper\"><img alt=\"\"></div><div class=\"highlights__text-box\"><h2 class=\"highlights__title\">Highlight Ideas</h2><p class=\"highlights__description\"> Create highlights and add notes with your comments will appear here </p></div>", 2)),
        _createVNode(AppButton, {
          class: _normalizeClass(["highlight__button highlights__read-button", hideButtonClass.value]),
          tag: "router-link",
          icon: readingButton.value.icon,
          to: __props.doc.startLinkParams()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(readingButton.value.text), 1)
          ]),
          _: 1
        }, 8, ["class", "icon", "to"])
      ]))
}
}

})